import { 
  CONFIRM_MAIL_CONFIRM, 
  PENDING, FULFILLED, REJECTED 
} from '../globals';

export const initialState = {
  isLoading: true,
  status: false,
  error: false,
  errorType: {
    time: true,
    completed: true,
    deleted: true,
    emailConfirmed: true,
  },
};

const reducer = (state = initialState, action) => {
  const { type, payload, } = action;

  switch (type) {
    case `${CONFIRM_MAIL_CONFIRM}_${PENDING}`:
      return {
        ...initialState,
        isLoading: true,
      };

    case `${CONFIRM_MAIL_CONFIRM}_${FULFILLED}`:
      return {
        ...state,
        isLoading: false,
        status: true,
        error: false,
      };

    case `${CONFIRM_MAIL_CONFIRM}_${REJECTED}`:
      return {
        ...state,
        isLoading: false,
        status: false,
        error: true,
        errorType: payload,
      };
    
    default:
      return state;
  }
};

export default reducer;


// WEBPACK FOOTER //
// ./src/reducers/confirmEmail.js